function hasThirdPartyConsent() {
  var cookieName = 'moove_gdpr_popup';
  var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
  if (match) {
    try {
      var consentData = JSON.parse(decodeURIComponent(match[2]));
      return consentData.thirdparty === true;
    } catch (e) {
      console.error('Failed to parse GDPR cookie:', e);
      return false;
    }
  }
  return false;
}
function hasGoogleMapsConsent() {
  // Check localStorage for consent flag OR third-party cookie consent
  return localStorage.getItem('artesGoogleMapsConsent') === 'true' || hasThirdPartyConsent();
}
function enableGoogleMapsConsent() {
  localStorage.setItem('artesGoogleMapsConsent', 'true');
}
function initMapSection() {
  var sections = document.querySelectorAll('.section-content-with-map__map-container');
  sections.forEach(function (section) {
    var embed = section.querySelector('.map-embed');
    var overlay = section.querySelector('.map-consent-overlay');
    var btn = section.querySelector('.map-enable-btn');
    function showMap() {
      if (embed && !embed.dataset.initialized) {
        var url = embed.getAttribute('data-embed-url');
        if (url) {
          var iframe = document.createElement('iframe');
          iframe.src = url;
          iframe.width = '100%';
          iframe.height = '350';
          iframe.style.border = '0';
          iframe.allowFullscreen = true;
          iframe.loading = 'lazy';
          iframe.referrerPolicy = 'no-referrer-when-downgrade';
          embed.appendChild(iframe);
          embed.dataset.initialized = 'true';
        }
      } else {
        return;
      }
      embed.style.display = '';
      overlay.style.display = 'none';
    }
    function showOverlay() {
      embed.style.display = 'none';
      overlay.style.display = '';
    }
    if (hasGoogleMapsConsent()) {
      showMap();
    } else {
      showOverlay();
      if (btn) {
        btn.addEventListener('click', function () {
          enableGoogleMapsConsent();
          showMap();
        });
      }
    }
  });
}
document.addEventListener('DOMContentLoaded', initMapSection);

// Expose for global use in cookie banner
window.artesEnableGoogleMapsConsent = function () {
  enableGoogleMapsConsent();
  initMapSection();
};
export default initMapSection;